import { createAuthorizationHeader, instanceFetch } from '../../../fetch';
import { ICpSuccessPayload } from '../../infra';

export const cpSuccess = async (payload: ICpSuccessPayload) => {
  try {
    const headers = createAuthorizationHeader();
    const response = await instanceFetch.post('/checkout/cp-success', payload, headers);
    return response;
  } catch (e) {
    console.error(e);
  }
};
